import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocale } from '../../i18n/locale-context.js';
export function ScopeReviewStep(props) {
    const { t } = useLocale();
    const dataSelected = new Set(props.currentDataScope);
    const opSelected = new Set(props.currentOperationalScope);
    const toggleData = (cat) => {
        const next = new Set(dataSelected);
        if (next.has(cat)) {
            next.delete(cat);
        }
        else if (props.requestedDataScope.includes(cat)) {
            // Only allow re-adding categories that were originally requested;
            // patient cannot expand scope beyond what the app requested.
            next.add(cat);
        }
        props.onNarrow({
            dataScope: Array.from(next),
            operationalScope: props.currentOperationalScope,
        });
    };
    const toggleOp = (cat) => {
        const next = new Set(opSelected);
        if (next.has(cat)) {
            next.delete(cat);
        }
        else if (props.requestedOperationalScope.includes(cat)) {
            next.add(cat);
        }
        props.onNarrow({
            dataScope: props.currentDataScope,
            operationalScope: Array.from(next),
        });
    };
    return (_jsxs("section", { "aria-labelledby": "scope-heading", children: [_jsx("h3", { id: "scope-heading", children: t('consent.scope_review.heading') }), _jsx("p", { children: t('consent.scope_review.body') }), _jsx("h4", { children: t('consent.scope_review.data_categories_heading') }), _jsx("ul", { "aria-label": t('consent.scope_review.requested_data_aria_label'), children: props.requestedDataScope.map((cat) => (_jsx("li", { children: _jsxs("label", { children: [_jsx("input", { type: "checkbox", checked: dataSelected.has(cat), onChange: () => toggleData(cat) }), ' ', cat] }) }, cat))) }), _jsx("h4", { children: t('consent.scope_review.operational_scope_heading') }), _jsx("ul", { "aria-label": t('consent.scope_review.requested_op_aria_label'), children: props.requestedOperationalScope.map((cat) => (_jsx("li", { children: _jsxs("label", { children: [_jsx("input", { type: "checkbox", checked: opSelected.has(cat), onChange: () => toggleOp(cat) }), ' ', cat] }) }, cat))) }), _jsxs("div", { role: "group", "aria-label": t('consent.scope_review.actions_aria_label'), children: [_jsx("button", { type: "button", onClick: props.onContinue, disabled: dataSelected.size === 0 || opSelected.size === 0, children: t('consent.scope_review.continue') }), _jsx("button", { type: "button", onClick: props.onCancel, children: t('consent.scope_review.cancel') })] })] }));
}
//# sourceMappingURL=scope-review-step.js.map